import {req} from 'nanoajax.js'

import {AuthStore} from '../auth'

import Actions from './Actions'
import Constants from './Constants'

class NetworkService {
   constructor() {
      this._locks = {}
   }

   locked(ref) {
      return undefined !== this._locks[ref]
   }

   cachePromise(ref) {
      return this._locks[ref]
   }

   cacheLock(ref, promise) {
      if (this.locked(ref)) {
         return this._locks[ref]
      }

      this._locks[ref] = promise

      return promise
         .then(resp => {
            delete this._locks[ref]

            return resp
         })
         .catch(resp => {
            delete this._locks[ref]
            throw resp
         })
   }

   create(data) {
      let payload = JSON.stringify(data),
         headers = {
            Authorization:  AuthStore.signV1('POST', Constants.NETWORK_URL, payload),
            'Content-Type': 'text/json'
         }

      return req.post(Constants.NETWORK_URL, payload, headers).then(([resp, _httpreq]) => {
         Actions.new(resp)

         return resp
      })
   }

   update(nid, data) {
      let payload = JSON.stringify(data),
         url = Constants.NETWORK_URL + '/' + nid,
         headers = {
            Authorization:  AuthStore.signV1('PUT', url, payload),
            'Content-Type': 'text/json'
         }

      return req
         .put(url, payload, headers)
         .then(([resp, _httpreq]) => Actions.update(nid, resp))
         .catch(err => {
            let newErr

            switch (err.req.status) {
               // bad data in input
               // either user, or organization was not found
               case 400:
                  newErr = new Error(err.data.error || err.data.message || 'unknown error')

                  newErr.req = err.req
                  newErr.data = err.data

                  throw newErr

               case 403:
                  newErr = new Error(err.data.error || err.data.message || 'unknown error')

                  newErr.req = err.req
                  newErr.data = err.data

                  throw newErr

               case 404:
                  const [type, ent] = (err.data.resource || '/').split('/')

                  newErr = new Error('Non-existing ' + type + ' ' + ent)

                  newErr.req = err.req
                  newErr.data = err.data

                  throw newErr

               default:
                  throw err
            }
         })
   }

   list() {
      const url = Constants.NETWORK_URL,
         headers = {Authorization: AuthStore.signV1('GET', url, '')}

      if (this.locked(url)) {
         return this.cachePromise(url)
      }

      return this.cacheLock(url, req.get(url, null, headers)).then(([resp, _httpreq]) =>
         Actions.list(resp),
      )
   }

   fetch(nid) {
      let url = Constants.NETWORK_URL + '/' + nid,
         headers = {Authorization: AuthStore.signV1('GET', url, '')}

      if (this.locked(url)) {
         return this.cachePromise(url)
      }

      return this.cacheLock(url, req.get(url, null, headers))
         .then(([resp, _httpreq]) => {
            Actions.change(nid, resp)

            return resp
         })
         .catch(err => {
            switch (err.req.status) {
               // Access denied, or whatever
               case 400:
               case 403:
                  break

               default:
                  throw err
            }

            return err
         })
   }
}

export default new NetworkService()



// WEBPACK FOOTER //
// lib/api/network/Service.js